import { Component, OnInit, AfterContentInit, ViewChild, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HTTPService, HelperService, DataService } from 'app/services';
import { templateTypes } from 'app/constants/templates/template-type';
import { autoLeapData } from 'app/constants/autoleap.constants';
import { TranslateService } from '@ngx-translate/core';
import { getLanguagePreferences } from 'app/constants/language-translate';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.scss'],
})
export class EmailTemplateComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('templateSubject', { read: ElementRef }) templateSubject: ElementRef;
  @ViewChild('templateTextArea', { read: ElementRef }) textArea: ElementRef;
  @ViewChild('templateFooter', { read: ElementRef }) templateFooter: ElementRef;
  @ViewChild('smsContents', { read: ElementRef }) smsContents: ElementRef;
  @ViewChild('smsFooter', { read: ElementRef }) smsFooter: ElementRef;

  company: any = {};
  routeSubscription: any;
  localizationSubscription: Subscription;
  template: any = {};
  focusedField: ElementRef;
  focusedFieldKey: string = 'contents';
  hSmsFooter: string = '';
  activeTab: number = 0;
  tags: any[] = [];
  isTemplateTypeOpen = false;
  templates = {
    key: templateTypes.confirmation,
    default: {
      _id: '',
      subject: '',
      contents: '',
      footer: '',
      smsFooter: '',
      smsContents: '',
      smsBottomContents: '',
    },
    new: {
      _id: '',
      subject: '',
      contents: '',
      footer: '',
      smsFooter: '',
      smsContents: '',
      smsBottomContents: '',
    },
  };
  role: string = '';
  templateConstant = templateTypes;
  isPayrixConnected = false;
  currentLang: string = 'en';
  companyLocalization: boolean = false;
  templateReviewMsgs: any = {
    REVIEW_REQUEST: 'This template will be used for Email and SMS when AutoLeap Internal Reviews are turned ON in the Review Settings, customer will be redirected to Internal Survey', 
    REVIEW_REMINDER: 'This template will be used for Email and SMS when AutoLeap Internal Reviews are turned ON in the Review Settings, customer will be redirected to Internal Survey', 
    RECEIPT_REVIEW: 'This template will be used for Email and SMS when AutoLeap Internal Reviews are turned ON in the Review Settings, customer will be redirected to Internal Survey', 
    REVIEW_REQUEST_GOOGLE: 'This template will be used for Email and SMS when AutoLeap Internal Reviews are turned off in the Review Settings, customer will be redirected to Google', 
    REVIEW_REMINDER_GOOGLE: 'This template will be used for Email and SMS when AutoLeap Internal Reviews are turned off in the Review Settings, customer will be redirected to Google', 
    RECEIPT_REVIEW_GOOGLE: 'This template will be used for Email and SMS when AutoLeap Internal Reviews are turned off in the Review Settings, customer will be redirected to Google'
  };

  constructor(private dataService: DataService, private httpService: HTTPService, private helperService: HelperService, private route: ActivatedRoute, private translate: TranslateService) { }

  ngOnInit() {
    this.getCompanyDetails();
    this.routeSubscription = this.route.data.subscribe((data) => {
      this.template = data;
      this.tags = data.tags;
      this.getTemplate(this.template.key);
      this.isPayrixConnected = this.dataService.isPayrixConnected;
    });
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      this.companyLocalization = value

      if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
    })
  }

  excludedTemplates(): boolean {
    const excludedKeys = ['WARRANTY_DISCLAIMER', 'INV_DISCLAIMER', 'DISCLAIMER', 'TIRE_WARRANTY_POLICY'];
    return !excludedKeys.includes(this.templates.key);
  }

  ngAfterViewInit() {
    this.focusedField = this.textArea;
  }

  setActiveTab(activeTab: number) {
    this.activeTab = activeTab;
  }

  setFocus(type: string) {
    this.focusedFieldKey = type;
    switch (type) {
      case 'subject':
        this.focusedField = this.templateSubject;
        break;

      case 'contents':
        this.focusedField = this.textArea;
        break;

      case 'footer':
        this.focusedField = this.templateFooter;
        break;

      case 'smsContents':
        this.focusedField = this.smsContents;
        break;

      case 'smsFooter':
        this.focusedField = this.smsFooter;
        break;
    }
  }

  /**
   * fetch template from the db
   *
   * @param template
   */
  getTemplate(template) {
    this.templates = {
      key: template,
      default: {
        _id: '',
        subject: '',
        contents: '',
        footer: '',
        smsFooter: '',
        smsContents: '',
        smsBottomContents: '',
      },
      new: {
        _id: '',
        subject: '',
        contents: '',
        footer: '',
        smsFooter: '',
        smsContents: '',
        smsBottomContents: '',
      },
    };

    if (['super', 'onboarder', 'engg', 'sales'].includes(this.role)) {
      this.httpService
        .getEmailTemplatesByType(template)
        .then((res: any) => {
          if (res) {
            const { _id, contents, subject, footer, smsFooter, smsContents, smsBottomContents } = res;
            this.templates = {
              key: template,
              default: {
                _id,
                subject,
                contents,
                footer,
                smsFooter,
                smsContents,
                smsBottomContents,
              },
              new: {
                _id,
                subject,
                contents,
                footer,
                smsFooter,
                smsContents,
                smsBottomContents,
              },
            };
          }
        })
        .catch((err) => { });
    } else {
      this.httpService
        // .getTemplatesByType(template)
        .getTemplatesByTypeLang(template, this.currentLang)
        .then((res: any) => {
          if (res) {
            const { _id, contents, subject, footer, smsFooter, smsContents, smsBottomContents } = res;
            this.templates = {
              key: template,
              default: {
                _id,
                subject,
                contents,
                footer,
                smsFooter,
                smsContents,
                smsBottomContents,
              },
              new: {
                _id,
                subject,
                contents,
                footer,
                smsFooter,
                smsContents,
                smsBottomContents,
              },
            };
          }
        })
        .catch((err) => { });
    }
  }

  /** fetch company details */
  getCompanyDetails() {
    const { companyId, isMultiLocationEnabled } = this.helperService.getCompany();
    this.role = this.helperService.getCompany().role;

    if (!['super', 'onboarder', 'engg', 'sales'].includes(this.role)) {
      this.httpService.getCompanyDetails(companyId).then(
        (company: any) => {
          if (company.shop && isMultiLocationEnabled) {
            this.company = company.shop;
          } else {
            this.company = company;
          }
        },
        (err) => { }
      );
    } else {
      this.company = autoLeapData;
    }
  }

  /** Insert tags in the template content */
  handleInsertTag(tag) {
    this.templates.new[this.focusedFieldKey] = this.helperService.insertTextInTextArea(this.focusedField.nativeElement, tag);
  }

  toggleIsTemplateType() {
    this.isTemplateTypeOpen = !this.isTemplateTypeOpen;
  }

  restoreDefault() {
    this.templates.new = this.templates.default;
  }

  onSubmit() {
    if (this.templates.new.subject && this.templates.new.contents) {
      if (this.templates.new._id) {
        this.updateTemplate({
          _id: this.templates.new._id,
          type: this.templates.key,
          subject: this.templates.new.subject,
          contents: this.templates.new.contents,
          footer: this.templates.new.footer,
          htmlContents: this.template.htmlContents,
          smsContents: this.template.new && this.template.new.smsContents,
          smsFooter: this.templates.new.smsFooter,
          smsBottomContents: this.templates.new.smsBottomContents,
          language: this.currentLang.toUpperCase(),
        });
      } else {
        this.createTemplate({
          type: this.templates.key,
          name: this.template.title,
          subject: this.templates.new.subject,
          contents: this.templates.new.contents,
          footer: this.templates.new.footer,
          htmlContents: this.template.htmlContents,
          smsContents: this.template.new && this.template.new.smsContents,
          smsFooter: this.templates.new.smsFooter,
          smsBottomContents: this.templates.new.smsBottomContents,
          language: this.currentLang.toUpperCase(),
        });
      }
    }
  }

  createTemplate(template) {
    if (['super', 'onboarder', 'engg', 'sales'].includes(this.role)) {
      this.httpService.createEmailTemplate(template).then(
        (res: any) => {
          this.templates.new._id = res._id;
          this.templates.default = this.templates.new;
          this.helperService.showToaster('success', `Successfully Saved Template`);
        },
        (err) => {
          this.helperService.showToaster('error', (err.error && err.error.error) || err.message);
        }
      );
    } else {
      this.httpService.createTemplate(template).then(
        (res: any) => {
          this.templates.new._id = res._id;
          this.templates.default = this.templates.new;
          this.helperService.showToaster('success', `Successfully Saved Template`);
        },
        (err) => {
          this.helperService.showToaster('error', (err.error && err.error.error) || err.message);
        }
      );
    }
  }

  updateTemplate(template) {
    if (['super', 'onboarder', 'engg', 'sales'].includes(this.role)) {
      this.httpService.updateEmailTemplate(template).then(
        (res: any) => {
          this.templates.default = this.templates.new;
          this.helperService.showToaster('success', `Successfully Saved Template`);
        },
        (err) => {
          this.helperService.showToaster('error', (err.error && err.error.error) || err.message);
        }
      );
    } else {
      this.httpService.updateTemplate(template).then(
        (res: any) => {
          this.templates.default = this.templates.new;
          this.helperService.showToaster('success', `Successfully Saved Template`);
        },
        (err) => {
          this.helperService.showToaster('error', (err.error && err.error.error) || err.message);
        }
      );
    }
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  handleChange(event: any) {
    // Get the index of the active tab
    const activeIndex = event.index;

    // Send 'EN' if the first tab is selected, 'FR' for the second tab
    if (activeIndex === 0) {
      this.currentLang = 'en';
      this.getTemplate(this.template.key);
    } else if (activeIndex === 1) {
      this.currentLang = 'fr';
      this.getTemplate(this.template.key);
      this.translate.use(this.currentLang);
    }

    // Do something with the language parameter
    console.log('Selected language:', this.currentLang);
  }
}
